import { Component, Fragment } from "react";
import Alert from "react-bootstrap/Alert"

class ErrorDisplay extends Component {
  render() {
    const {errors} = this.props

    return(
      <>
        {
          Object.keys(errors).length !== 0 && errors.constructor === Object &&
          <Alert variant="danger">
            <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
            {
              Object.keys(errors).map((key, index) => {
                return(
                  <Fragment key={index}>
                    <span>{key === 'base' ? '*' : key}</span>
                    {errors[key].map((error, index) => {
                      return(
                        <p key={index}>
                           - {error}
                        </p>
                      )
                    })
                    }
                  </Fragment>
                )
              })
            }
          </Alert>
        }
      </>
    )
  }
}

export default ErrorDisplay